import Vue from 'vue'
import api from '@/api/client'

const state = Vue.observable({
  list: [],
  loaded: false,
  loading: false,
  detailCache: {}
})

export async function loadArticles(force = false) {
  if (state.loading) return state.list
  if (state.loaded && !force) return state.list

  state.loading = true
  try {
    const res = await api.getArticles()
    state.list = res.data.list || []
    state.loaded = true
  } catch {
    state.list = []
    state.loaded = true
  } finally {
    state.loading = false
  }
  return state.list
}

export function getArticles() {
  return state.list
}

export async function fetchArticleById(id) {
  const numId = Number(id)
  if (state.detailCache[numId]) {
    return state.detailCache[numId]
  }
  try {
    const res = await api.getArticle(numId)
    state.detailCache[numId] = res.data
    return res.data
  } catch {
    return null
  }
}

export function getArticleByIdSync(id) {
  const numId = Number(id)
  if (state.detailCache[numId]) return state.detailCache[numId]
  return getArticles().find(a => a.id === numId) || null
}

export function invalidateArticles() {
  state.loaded = false
  state.detailCache = {}
}

export const articlesStore = state

export default {
  get list() { return state.list },
  get loaded() { return state.loaded },
  get loading() { return state.loading },
  loadArticles,
  fetchArticleById,
  getArticleByIdSync,
  invalidateArticles
}
